import React from 'react';

export default class CountDown extends React.PureComponent {
    state = {
        day: '00',
        hour: '00',
        minute: '00',
        second: '00',
    }
    timer = null;
    componentDidMount() {
        const { endTime } = this.props;
        console.log(endTime - new Date().getTime());
        if (endTime) {
            const currentTime = new Date().getTime();
            let sysSecond = (endTime - currentTime) / 1000;
            this.timer = setInterval(() => {
                if (sysSecond > 0) {
                    sysSecond -= 1;
                    const day = this.parsetNum(Math.floor((sysSecond / 3600) / 24));
                    const hour = this.parsetNum(Math.floor((sysSecond / 3600) % 24));
                    const minute = this.parsetNum(Math.floor((sysSecond / 60) % 60));
                    const second = this.parsetNum(Math.floor(sysSecond % 60));
                    this.setState({ day, hour, minute, second });
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        }
    }
    componentWillUnmount() {
        clearInterval(this.timer);
    }
    parsetNum = (num) => {
        return num < 10 ? `0${num}` : num;
    }
    render() {
        const { day, hour, minute, second } = this.state;
        return <div className="count-down-component">
        <span className="count-down-span">{day}</span>天<span className="count-down-span">{hour}</span>时<span className="count-down-span">{minute}</span>分<span className="count-down-span">{second}</span>秒
    </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/dailyAttendancePage/CountDown.jsx